<template>
  <div class="text-standard">
    <div class="container mx-auto flex flex-col md:flex-row pt-10 md:pt-16">
      <div class="laptop:w-6/12 p-5 md:p-0 md:mx-8 laptop:p-0 md:w-3/6 lg:min-h-0 flex-grow" style="min-height:475px">
        <iframe v-if="youtubeEnabled" style="width:100%; min-height:475px" class="h-full"
                src="https://www.youtube.com/embed/f4kk17h4BZY?rel=0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen />
        <iframe v-if="!youtubeEnabled" style="width:100%; min-height:475px" class="h-full"
                src="https://www.youtube-nocookie.com/embed/f4kk17h4BZY?rel=0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen />
      </div>
      <div
        class="laptop:w-5/12 p-5 md:p-0 laptop:pl-0 laptop:mx-24 md:mx-8 md:w-1/2 text-standard justify-center flex flex-col">
        <h2
          class="text-standard fullhd:text-55px laptop:text-55px font-bold mb-12 md:w-full laptop:w-full md:text-4xl leading-normal laptop:leading-tight" v-html="$t('onestring.title')" />
        <div v-html="$t('onestring.subtitle')" />
        <!-- <p><b>CASE STORY:</b><br />ONE STRING a sustainable and comfortable shoe by Pegolo.<br /><br /></p>
        <p>Gianluca Pegolo, a student of Politecnico di Milano, harnesses new technologies for product design, rapid
          prototyping and communication in app-free projects.</p> -->
      </div>
    </div>

    <div class="w-full bg-highlight bg-visualizer-medium laptop:bg-visualizer bg-center bg-cover mt-150px relative">
      <video class="fullscreen hidden laptop:block" src="~/assets/img/video/onestring-2.mp4" playsinline autoplay muted
             loop />
      <video class="fullscreen block laptop:hidden" src="~/assets/img/video/onestring-1.mp4" playsinline autoplay muted
             loop />
      <div class="container h-full mx-auto relative">
        <div class="flex flex-col justify-around h-full laptop:w-6/12 w-full md:w-10/12 p-5 laptop:ml-24 md:ml-8 z-50">
          <div>
            <h3
              class="text-white text-4xl laptop:text-55xl md:w-3/4 md:text-4xl laptop:w-full font-bold leading-tight"
              v-html="$t('onestring.whitetitle')" />
          </div>
        </div>
      </div>
    </div>

    <Box textAlignment="left">
      <template #text>
        <MARSTitle font-size="md:text-45xl lg:text-45xl laptop:text-52xl"><div v-html="$t('onestring.title-1')" /></MARSTitle>
        <p class="text-standard mt-4 mb-8" v-html="$t('onestring.box-1')" />
      </template>
      <template #image>
        <video src="~/assets/img/video/product-tag.mp4" playsinline autoplay muted loop />
      </template>
    </Box>

    <Box textAlignment="left">
      <template #text>
        <MARSTitle font-size="md:text-45xl lg:text-45xl laptop:text-52xl"><div v-html="$t('onestring.title-2')" /></MARSTitle>
      </template>
      <template #image>
        <div class="text-standard mt-4 mb-8" v-html="$t('onestring.box-2')" />
      </template>
    </Box>

    <div class="w-full bg-center bg-cover mt-150px relative">
      <img v-if="$i18n.locale != 'it'" loading="lazy" class="fullscreen hidden laptop:block w-full" src="~/assets/img/onestring/instructions_en_h.webp">
      <img v-if="$i18n.locale != 'it'" loading="lazy" class="fullscreen block laptop:hidden mx-auto mb-150px" src="~/assets/img/onestring/instructions_en_v.webp">
      <img v-if="$i18n.locale == 'it'" loading="lazy" class="fullscreen hidden laptop:block w-full" src="~/assets/img/onestring/instructions_it_h.webp">
      <img v-if="$i18n.locale == 'it'" loading="lazy" class="fullscreen block laptop:hidden mx-auto mb-150px" src="~/assets/img/onestring/instructions_it_v.webp">
    </div>

    <Box textAlignment="right">
      <template #text>
        <MARSTitle font-size="md:text-45xl lg:text-45xl laptop:text-52xl"><div v-html="$t('onestring.title-3')" /></MARSTitle>
        <p class="text-standard mt-4 mb-24" v-html="$t('onestring.box-3')" />
        <MARSTitle font-size="md:text-45xl lg:text-45xl laptop:text-52xl"><div v-html="$t('onestring.title-4')" /></MARSTitle>
        <p class="text-standard mt-4" v-html="$t('onestring.box-4')" />
        <div class="flex mt-12 gap-16 cursor-pointer mb-24">
          <img loading="lazy" src="~/assets/img/onestring/btn-fullscreen.svg" onclick="document.querySelector('#fullscreen_flyer').requestFullscreen()">
          <a href="/download/MyARStudio_OneString_A5_flyer.pdf" download="MyARStudio_OneString_A5_flyer.pdf" title="Download OneString ProductTag flyer"><img loading="lazy" src="~/assets/img/onestring/btn-download.svg"></a>
        </div>
      </template>
      <template #image>
        <img id="fullscreen_flyer" loading="lazy" src="~/assets/img/onestring/flyer.webp">
      </template>
    </Box>
    <div class="laptop:mt-150px pt-10" />
  </div>
</template>

<script setup lang="ts">
import MARSTitle from '@/components/MARSTitle.vue'
import Box from '@/components/Box.vue'
import { useIubenda } from 'mars-iubenda-vite';

const {youtubeEnabled} = useIubenda()
// TODO: is the video at the top of the page the right one? I remember another video where Pegolo rides a bike and prepares for the Milan week?
</script>

<style scoped>
.console {
  background-image: url("~/assets/img/examples/anamorphic-hero.webp");
}

video.fullscreen {
  position: absolute;
  z-index: 0;
  object-fit: cover;
  width: 100%;
  height: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
